export const GET_AUTOMATIONS_METADATA_ENDPOINT =
  '/p/v1/automation-engine/automations-metadata';
